import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "backdrop" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  class: "backtop fas fa-arrow-up",
  href: "#"
}, null, -1)
const _hoisted_3 = {
  class: "mobile-menu",
  style: {"justify-content":"space-around"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "home",
  title: "Home Page"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }),
  /*#__PURE__*/_createElementVNode("span", null, "Inicio")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "cart-btn",
  title: "Cartlist"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shopping-basket" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Carrito", -1)
const _hoisted_8 = {
  key: 1,
  href: "setting",
  class: "header-widget",
  title: "Configuraciones"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-cog" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Configuracion", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Cliente", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Contraseña", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("a", {
      class: "backtop2 fas fa-arrow-down",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScrollBottom && _ctx.onScrollBottom(...args)))
    }),
    (_ctx.NotSinglePage())
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          ref: "hijorRef"
        }, null, 512))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    }),
    (_ctx.NotSinglePage())
      ? (_openBlock(), _createBlock(_component_Footer, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (!_ctx.isChecout())
        ? (_openBlock(), _createElementBlock("button", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("sup", null, _toDisplayString(_ctx.cantidadItem), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.UserLogued && _ctx.UserLogued?.Tipo_usuario == 'administrador')
        ? (_openBlock(), _createElementBlock("a", _hoisted_8, _hoisted_11))
        : _createCommentVNode("", true),
      (
              _ctx.UserLogued?.Nombre &&
              (_ctx.UserLogued?.Tipo_usuario == 'administrador' ||
                _ctx.UserLogued?.Tipo_usuario == 'representante') &&
              _ctx.UserLogued?.puedeSeleccionarEmpresa
            )
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            href: "#",
            class: "header-widget",
            title: "buscar un Cliente",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
          }, _hoisted_14))
        : _createCommentVNode("", true),
      (_ctx.UserLogued?.Nombre && _ctx.UserLogued?.Tipo_usuario == 'administrador')
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openModalPassword && _ctx.openModalPassword(...args))),
            href: "#",
            class: "header-widget",
            title: "Cambiar Contraseña"
          }, _hoisted_17))
        : _createCommentVNode("", true)
    ])
  ]))
}